import { useEffect, useState } from 'react';

const LicenseError = () => {
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        setAnimate(true);
    }, []);

    return (
        <div className='flex h-auto items-center justify-center'>
            <div
                className={`ease-cubic-bezier[.4,0,.2,1] w-full max-w-md rounded-xl bg-white p-10 text-center shadow-xl transition-all duration-600 ${animate ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
                <svg
                    width='64'
                    height='64'
                    viewBox='0 0 64 64'
                    fill='none'
                    className={`mx-auto mb-4 ${animate ? 'animate-shake' : ''}`}>
                    <circle
                        cx='32'
                        cy='32'
                        r='32'
                        fill='#6366f1'
                    />
                    <path
                        d='M32 18v18'
                        stroke='#fff'
                        strokeWidth='3'
                        strokeLinecap='round'
                    />
                    <circle
                        cx='32'
                        cy='44'
                        r='2.5'
                        fill='#fff'
                    />
                </svg>
                <h1 className='mb-2 text-2xl font-bold text-slate-800'>License Configuration Error</h1>
                <p className='mb-6 text-base text-slate-600'>
                    Your licenses and functionalities have not been configured correctly. Please contact your administrator or support team to resolve this
                    issue.
                </p>

                <style>
                    {`
                        @keyframes shake {
                            0% { transform: translateX(0); }
                            20% { transform: translateX(-6px); }
                            40% { transform: translateX(6px); }
                            60% { transform: translateX(-4px); }
                            80% { transform: translateX(4px); }
                            100% { transform: translateX(0); }
                        }
                        .animate-shake {
                            animation: shake 0.6s;
                        }
                        .ease-cubic-bezier\\[\\.4\\,0\\,\\.2\\,1\\] {
                            transition-timing-function: cubic-bezier(.4,0,.2,1);
                        }
                        .duration-600 {
                            transition-duration: 600ms;
                        }
                    `}
                </style>
            </div>
        </div>
    );
};

export default LicenseError;
